import React from "react";
import axios from "axios";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../ui/alert-dialog";
import { API, auth } from "./practiceApi";

// Pause (day count stands still, no reminders) / Resume / End. Ending never deletes their installation.
export const PlanControls = ({ p, onChange }) => {
  const act = (what, msg) => axios.post(`${API}/api/practice/${what}`, {}, auth())
    .then((r) => { onChange(what === "end" ? null : r.data.plan); toast.success(msg); window.dispatchEvent(new Event("soulumo:practice-ended")); })
    .catch(() => toast.error("Couldn't update your plan. Please try again."));
  const btn = "text-xs text-[#b9ad8f] underline-offset-4 transition-colors hover:text-[#f3ecd9] hover:underline";
  return (
    <div className="mt-6 flex items-center gap-5 border-t border-[#2b3d5e] pt-4" data-testid="practice-controls">
      {p.paused
        ? <button type="button" className={btn} onClick={() => act("resume", `Welcome back. Day ${p.day} carries on.`)} data-testid="practice-resume-btn">Resume my 21 days</button>
        : <button type="button" className={btn} onClick={() => act("pause", "Paused. Your day count waits for you.")} data-testid="practice-pause-btn">Pause</button>}
      <AlertDialog>
        <AlertDialogTrigger asChild><button type="button" className={btn} data-testid="practice-end-btn">End plan</button></AlertDialogTrigger>
        <AlertDialogContent className="border-[#2b3d5e] bg-[#0b1a33] text-[#f3ecd9]" data-testid="practice-end-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>End your 21-Day plan?</AlertDialogTitle>
            <AlertDialogDescription className="text-[#cfc6ae]">Your installation and Night Version stay in your library. You can start a new plan any time.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="border-[#2b3d5e] bg-transparent text-[#f3ecd9]" data-testid="practice-end-cancel">Keep going</AlertDialogCancel>
            <AlertDialogAction className="bg-[#d7bb7a] text-[#0b1a33] hover:bg-[#d7bb7a]/90" onClick={() => act("end", "Plan ended. Start a new one whenever you like.")} data-testid="practice-end-confirm">End plan</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
